// What the legal bar at the foot of every page links to, defined once.
//
// Three renderers consume this list: the web app's Svelte footer
// (apps/web/src/lib/nav/LegalFooter.svelte), the static footer the documentation
// build writes into every page (@doc-cheap/site-chrome), and the acceptance
// notice on the registration form. They are separate builds and separate
// languages, so nothing but a shared definition keeps them pointing at the same
// three addresses — and these three in particular have to be reachable from
// wherever a reader is, because that is what makes the texts part of the
// agreement rather than something published somewhere.
//
// The labels are short on purpose: this is a bar under the page, not a section
// of the site.

export interface LegalLink {
  /** Stable handle for the entry, independent of the label a reader sees. */
  readonly id: string;
  readonly href: string;
  readonly label: string;
}

export const LEGAL_LINKS: readonly LegalLink[] = [
  { id: "terms", href: "/terms", label: "Terms" },
  { id: "privacy", href: "/privacy", label: "Privacy" },
  { id: "data-processing", href: "/data-processing", label: "Data processing" },
];
